/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_WhatsappInputs */

const en_method_whatsapp = /** @type {(inputs: Method_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`whatsapp`)
};

const he_method_whatsapp = /** @type {(inputs: Method_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`וואטסאפ`)
};

/**
* | output |
* | --- |
* | "whatsapp" |
*
* @param {Method_WhatsappInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_whatsapp = /** @type {((inputs?: Method_WhatsappInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_WhatsappInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_whatsapp(inputs)
	return he_method_whatsapp(inputs)
});